import { useId } from 'react';
import { Stack, Switch } from '@mui/material';
import type { FieldElement } from '../../format/form-definition';
import { useBuilder } from '../context';
import { RuleExtras, RuleHead } from './RuleParts';
import { ruleName, validationOf } from './rules';

export const UniqueRule = ({ field }: { field: FieldElement }) => {
  const { edit } = useBuilder();
  const unique = validationOf(field, 'unique');
  const nameId = useId();
  return (
    <Stack useFlexGap spacing={1.5}>
      <RuleHead name={ruleName(field, 'unique')} nameId={nameId}>
        <Switch
          size="small"
          checked={unique !== undefined}
          onChange={event =>
            edit(
              event.target.checked
                ? { kind: 'setValidation', fieldId: field.id, validation: { kind: 'unique' } }
                : { kind: 'removeValidation', fieldId: field.id, validationKind: 'unique' },
            )
          }
          slotProps={{ input: { role: 'switch', 'aria-labelledby': nameId } }}
        />
      </RuleHead>
      {unique && <RuleExtras field={field} validation={unique} />}
    </Stack>
  );
};
